import { render } from "./ControlRelay.vue?vue&type=template&id=fccbbfa8"
import script from "./ControlRelay.vue?vue&type=script&lang=js"
export * from "./ControlRelay.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__